// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","305":"component---src-templates-recipe-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"e7ecc799601c3d6ed108","305":"fd3d3bc01583a192f1bd","691":"e8ed6c04d2eefcf3568e"}[chunkId] + ".js";
};